module.exports = __webpack_public_path__ + "assets-cabinet/img/arrow-left.4081f3c0.svg";